export var mapingCardFundingSource = function (array) {
    if (!array) {
        return 'all';
    }
    if (array.length === 1) {
        return array[0].toLowerCase();
    }
    var isCredit = array.includes('CREDIT');
    var isDebit = array.includes('DEBIT');
    if (isCredit && isDebit) {
        return 'all';
    }
    if (isCredit) {
        return 'credit';
    }
    if (isDebit) {
        return 'debit';
    }
    return 'all';
};
